// extracted by mini-css-extract-plugin
export default {"loadingSkeleton":"Ga290fd","loading-skeleton":"G527a89"};